"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSuspense = exports.Suspense = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var UI_1 = require("../UI");
exports.Suspense = function (props) {
    var fallback;
    if (props.fallback !== undefined) {
        fallback = props.fallback;
    }
    else {
        var loader = UI_1.useUIContext().useLoader({ isLoading: true }).loader;
        fallback = loader;
    }
    return react_1.default.createElement(react_1.Suspense, tslib_1.__assign({ fallback: fallback || null }, props));
};
exports.withSuspense = function (component) {
    return react_1.default.createElement(exports.Suspense, null, component);
};
//# sourceMappingURL=Suspense.js.map